import "./styles.scss";

import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  getStudentPlansUser,
  getNextClassesStudent,
  getWordofthedayByDate,
  getPreviousClassesStudent,
  getLastLanguageOfFormStudent,
} from "../../store/middleware";
// import CardQuizzes from "../classDetails/CardQuizzes";
import SelectLanguages from "../classDetails/SelectLanguages";
import CardNextClasses from "../classDetails/CardNextClasses";
import CardWordoftheday from "../classDetails/CardWordoftheday";
import ModalQuestionnairesView from "../ModalQuestionnairesView";
import ButtonStudyWithAI from "../classDetails/ButtonStudyWithAI";
import { endLoading, initLoading } from "../../store/slices/generics.slice";
import { clearPreviousClassesStudent } from "../../store/slices/student.slice";
// import CardNoteNoteCoordinator from "../classDetails/CardNoteNoteCoordinator";
import CardPreviousClassesStudent from "../classDetails/CardPreviousClassesStudent";
import PlaceholderPlans from "../../assets/images/placeholder/placeholder-noplan.png";

const languageFormattedFlag = { EN: 1, ES: 2, PT: 3, FR: 4 };
const languageFormattedId = { 1: "EN", 2: "ES", 3: "PT", 4: "FR", 101: "CS-US-IN" };

const DetailContentStudent = ({ student = null, setActiveTab }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { plans } = useSelector((state) => state.studentReducer);
  const { allPreviousClassesStudent, allNextClassesStudent } = useSelector((state) => state.studentReducer);

  const [language, setLanguage] = useState();
  const [moreClassLimit, setMoreClassLimit] = useState(5);
  const [allowedLanguage, setAllowedLanguage] = useState([]);
  const [showModalQuestionnaires, setShowModalQuestionnaires] = useState(false);
  const [lastLanguageOfFormStudent, setLastLanguageOfFormStudent] = useState({});

  const userId = student ? Number(student?.userId) : user?.id;
  const studentId = student ? Number(student?.id) : user?.studentId;
  const customLanguage = plans && plans[0].studentPlanLanguages[0].lingoLanguage.customLang;

  const levelStudent =
    allPreviousClassesStudent?.length > 0 &&
    allPreviousClassesStudent[allPreviousClassesStudent?.length - 1][0]?.cycleAndLevel[0]?.level;

  const sequentialScheduleId = lastLanguageOfFormStudent?.currentLanguage?.[0]?.sequentialScheduleId;
  const getData = async () => {
    try {
      await dispatch(initLoading());
      await dispatch(clearPreviousClassesStudent());

      let newPlan = [];

      if (user?.role === "student") {
        newPlan = plans?.flatMap((item) => item.studentPlanLanguages.map((lang) => lang.lingoLanguage.id));
      } else {
        const response = await dispatch(getStudentPlansUser(student?.userId));
        const studentPlanLanguages = response?.flatMap((item) =>
          item.studentPlanLanguages.map((lang) => lang.lingoLanguage.id),
        );
        newPlan = studentPlanLanguages;
      }
      setAllowedLanguage(newPlan);

      const payload = { type: "student", studentId };
      const data = await dispatch(getLastLanguageOfFormStudent(payload));

      setLastLanguageOfFormStudent(data);
      const currentLanguageId = data?.currentLanguage[0]?.lingoLanguageId;
      const lastDoneLanguageId = data?.lastDoneLanguage[0]?.lingoLanguageId ?? newPlan[0];

      setLanguage(languageFormattedId[currentLanguageId ?? lastDoneLanguageId]);
      await handleGetClassContent(currentLanguageId ?? lastDoneLanguageId, true);
    } catch (err) {
      console.log(err);
    } finally {
      // await dispatch(endLoading());
    }
  };

  const handleOpenModalQuestionnaires = () => setShowModalQuestionnaires(true);

  const handleGetClassContent = async (lingoLanguageId, loading = false) => {
    try {
      loading && dispatch(initLoading());

      const payloadClass = { lingoLanguageId, studentId, type: "student" };
      const langFormatted =
        lingoLanguageId === 1 ? "EN" : lingoLanguageId === 2 ? "ES" : lingoLanguageId === 3 ? "PT" : "FR";

      dispatch(getWordofthedayByDate(langFormatted, moment().format("YYYY-MM-DD")));
      dispatch(getNextClassesStudent(payloadClass));
      await dispatch(getPreviousClassesStudent(payloadClass));
    } catch (err) {
      console.log(err);
    } finally {
      loading && dispatch(endLoading());
    }
  };

  const handleMoreContent = () => setMoreClassLimit(10);

  const handleOnclickOptions = (value) => {
    setLanguage(value);
    handleGetClassContent(languageFormattedFlag[value], true);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="containerDetailContentStudent">
      <SelectLanguages language={language} allowedLanguage={allowedLanguage} onClickOptions={handleOnclickOptions} />

      {showModalQuestionnaires && (
        <ModalQuestionnairesView
          userId={userId}
          showModal={showModalQuestionnaires}
          setShowModal={setShowModalQuestionnaires}
        />
      )}

      <div className="wrapperContent">
        <div className="leftDiv">
          {!customLanguage && <CardWordoftheday level={levelStudent} />}
          {customLanguage && (
            <button onClick={handleOpenModalQuestionnaires} className="btnOpenModal">
              {t("OPEN_MODAL_QUESTIONNAIRES")}
            </button>
          )}
          <ButtonStudyWithAI setActiveTab={setActiveTab} />
          {/* <CardQuizzes /> */}
          {/* <CardNoteNoteCoordinator /> */}
        </div>

        <div className="rightDiv">
          {allPreviousClassesStudent?.length > 0 ? (
            <>
              <h4 className="title">{t("PREVIOUS_CLASSES")}</h4>

              <div className="wrapperClasses">
                {allPreviousClassesStudent?.slice(-3).map((item, index) => (
                  <CardPreviousClassesStudent
                    key={index}
                    data={item}
                    index={index}
                    sequentialScheduleId={sequentialScheduleId}
                    length={allPreviousClassesStudent?.slice(-3)?.length}
                  />
                ))}
              </div>

              <div className="headerContent">
                <h4 className="title">{t("BTN_UPCOMING_CLASS")}</h4>
              </div>

              <div className="wrapperClasses">
                {allNextClassesStudent
                  ?.filter((item) => item !== null)
                  ?.slice(0, moreClassLimit)
                  ?.map((item, index) => (
                    <CardNextClasses key={index} data={item} sequentialScheduleId={sequentialScheduleId} />
                  ))}

                {moreClassLimit !== 10 && (
                  <div className="buttonMoreClass" onClick={handleMoreContent}>
                    <button>{t("MORE_CLASSES")}</button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="wrapperEmptyTitle">
              <h3 className="emptyTitle">{t("FIRST_CLASS_CONTENT")}</h3>
              <img src={PlaceholderPlans} alt="No Result" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailContentStudent;
